import React, { useState, useEffect } from 'react';

import { observer } from 'mobx-react-lite';
import Stack from '@mui/joy/Stack';
import Card from '@mui/joy/Card';
import Divider from '@mui/joy/Divider';
import Typography from '@mui/joy/Typography';
import Tooltip from '@mui/joy/Tooltip';
import { DateOrTime } from 'components/Date';
import AspectRatio from '@mui/joy/AspectRatio';
import useFile from 'hooks/useFile';
import useUserIdentity from 'hooks/useUserIdentity';
import { FileType } from 'stores/file_store';
import { getIcon } from 'utils/misc';
import { Error } from 'components/FancyToast';
import { FileAssociationType } from 'stores/file_association_store';

const ThumbnailViewer = observer(({association, size=42}: {association: FileAssociationType, size?: number}) => {
    const AttachmentIcon = getIcon('Attachment');
    const { getFile, fetchFile, fetchThumbnailUrl } = useFile();
    const { currentIdentity } = useUserIdentity();
    // show a larger version of the thumbnail?

    const [signedUrl, setSignedUrl] = useState<string | null>(null);

    // console.log("getfile:", getFile(association.file));
    // const ourFile = getFile(association.file);
    useEffect(() => {
        if(!association.file) return
        const f = getFile(association.file);
        if(!f) {
            fetchFile(currentIdentity.uuid, association.uuid);
        }

    }, [association.uuid]);

    useEffect(() => {
        if(!signedUrl) {
            fetchThumbnailUrl(
                currentIdentity?.uuid,
                association.uuid
            ).then((s) => {
                s && setSignedUrl(s);
            });

        }
    }, [association?.uuid]);


    //console.log("Viewer: ", ourFile, signedUrl);

    if(!signedUrl)
        return <AttachmentIcon fontSize="xl4" />;

    else {
        return (
            <Stack>
                <AspectRatio ratio={1} sx={{ width: size, borderRadius: 'sm' }}>
                    <img width={size} src={signedUrl} />
                </AspectRatio>
            </Stack>
        );
    }
});



const FileItem = observer(({ association }: { association: FileAssociationType }) => {
    const { fetchFile, getDownloadUrl } = useFile();
    const { currentIdentity } = useUserIdentity();
    const [file, setFile] = React.useState<FileType | null>(null);
    const [embiggened, setEmbiggened] = React.useState(false);
    const DownloadIcon = getIcon('Download');

   React.useEffect(() => {
        fetchFile(currentIdentity.uuid, association.uuid)
            .then((d) => {
                if(d) {
                    setFile(d);
                }

            });
   }, [association.uuid, currentIdentity.uuid, fetchFile]);



    const redirectToDownload = (disposition: string) => {
        const win = window.open(undefined, "_blank");

        getDownloadUrl(currentIdentity.uuid, association.uuid, disposition).
            then((url: string | null) => {
                if(url) {
                    if(win) {
                        win.location = url;
                    }
                    else {
                        window.location.href = url;
                    }
                }
                else {
                    Error("Unable to get download url");
                }
            });
    };

    if (!file)
        return <Typography level="body-xs">Loading file</Typography>;

    return (

            <Stack direction={embiggened ? "column" : "row"}
                spacing={2}
                alignItems="flex-start">
                <Tooltip arrow title={`Click to see a ${embiggened ? 'smaller' : 'larger'} version of ${file.filename}`}>
                    <Stack
                        sx={{ cursor: 'pointer' }}
                        onClick={() => setEmbiggened(!embiggened)}
                    >

                        <ThumbnailViewer
                            size={embiggened ? 500 : 100}
                            association={association} />

                    </Stack>
                </Tooltip>

                {embiggened &&
                    <>
                    <Card
                          sx={{width: '500px'}}
                            variant="soft"
                        >
                    <Stack spacing={0.5}>

                        <Tooltip arrow title={file.filename}>
                            <Typography
                                overflow="hidden"
                                level="body-sm"
                                color="primary"
                                noWrap
                                sx={{
                                    cursor: "pointer", overflow: "hidden",
                                    textOverflow: "ellipsis", width: "20rem"
                                }}
                                onClick={() => redirectToDownload('inline')}
                            >
                                {file.filename}
                            </Typography>
                        </Tooltip>

                            <Tooltip arrow title={"Click to download this file"}>
                                <Typography
                                    startDecorator={<DownloadIcon />}
                                    sx={{ cursor: "pointer" }}
                                    onClick={() => redirectToDownload('attachment')}
                                    level="body-xs"
                                >Download File</Typography>
                            </Tooltip>

                            <Typography
                                level="body-xs"
                            ><DateOrTime ts={file.date_created} />
                            </Typography>

                            </Stack>
                            </Card>
                            <Divider />
                            </>
                }

            </Stack>


    );
});

export default FileItem;
